document.querySelectorAll("a[data-email-user]").forEach(link => {
  const address = `${link.dataset.emailUser}@${link.dataset.emailDomain}`
  link.href = `mailto:${address}`
  link.textContent = address
})
